import React, { useContext, useEffect } from 'react'

import UserContext from 'contexts/UserContext'
import FrIcon from '../assets/drapeauxCarres/FRA.svg'
import GrcIcon from '../assets/drapeauxCarres/grc.svg'
import ItaIcon from '../assets/drapeauxCarres/ita.svg'
import NldIcon from '../assets/drapeauxCarres/nld.svg'
import PrtIcon from '../assets/drapeauxCarres/prt.svg'
import LuxIcon from '../assets/drapeauxCarres/lux.svg'
import GerIcon from '../assets/drapeauxCarres/ger.svg'
import DeuIcon from '../assets/drapeauxCarres/deu.svg'
import AutIcon from '../assets/drapeauxCarres/aut.svg'
import BelIcon from '../assets/drapeauxCarres/bel.svg'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import Gift from 'assets/iconTsx/gift'
import Fleche from 'assets/flecheRight.svg'

interface Props {
  euroValue: number
  handleEuroChange: any
  taux: number
  error: boolean
  com: any
  number: number 
  setEuroValue: (value: number) => void
  crossedOutValue?:number |null
}
const InputCalculateMontantEnvoyer: React.FC<Props> = ({
  euroValue,
  handleEuroChange,
  taux,
  error,
  com,
  number,
  setEuroValue,
  crossedOutValue
}) => {
  const { user } = useContext(UserContext)

  const { TransferData } = useContext(transferBeneficiaryContext)

  const optionsPaysSelected: { icon: any; code: string; frenshName: string; prefix: string }[] = [
    { icon: FrIcon, frenshName: 'France', code: 'FRA', prefix: '+33' },
    { icon: DeuIcon, frenshName: 'Espagne', code: 'ESP', prefix: '+34' },
    { icon: AutIcon, frenshName: 'Autriche', code: 'AUT', prefix: '+43' },
    { icon: BelIcon, frenshName: 'Belgique', code: 'BEL', prefix: '+39' },
    { icon: GrcIcon, frenshName: 'Grèce', code: 'GRC', prefix: '+32' },
    { icon: ItaIcon, frenshName: 'Italie', code: 'ITA', prefix: '+30' },
    { icon: NldIcon, frenshName: 'Pays Bas', code: 'NLD', prefix: '+31' },
    { icon: PrtIcon, frenshName: 'Portugal', code: 'PRT', prefix: '+351' },
    { icon: LuxIcon, frenshName: 'Luxembourg', code: 'LUX', prefix: '+352' },
    { icon: GerIcon, frenshName: 'Allemagne', code: 'DEU', prefix: '+49' },
  ]

  useEffect(() => {
    if (TransferData) {
      const euroValue = TransferData.euroValue
      if (typeof euroValue === 'number') {
        setEuroValue(euroValue)
      }
    }
  }, [])

  return (
    <div className='flex flex-col w-full font-roboto font-medium '>
    <div className="flex items-center gap-[24px] w-full ">
        <div className={`flex flex-col h-[130px] sm:h-[120px] w-full`}>
          <div className='h3' >
            Montant à envoyer <span className="text-[#FF0000]">*</span>
          </div>
          <div className='flex border focus-within:border-[#5754E5] border-[#AEB6FB] w-full rounded-[16px] h-[56px] items-center  px-4 mt-[12px]  gap-[12px]'>

            {Array.from(
              new Set(
                optionsPaysSelected.map(
                  (item: any, index: number) =>
                    item.code === user?.user?.address?.country?.code && (
                      <div
                        className={`bg-[#F1F1FF] rounded-[8px]  h-[32px] px-3 justify-center  flex items-center  
                        `}
                        key={index}
                      >
                        <img src={item.icon} width={25} height={25}/>
                        <span className="text-[#8F8FCD] text-[15px] pl-1">{user?.user?.address?.country?.code}</span>
                      </div>
                    ),
                ),
              ),
            )}
            <input
              type="text"
              placeholder="valeur en euro"
              value={isNaN(euroValue) ? "" : euroValue} 
              onChange={(e: any) => {
                handleEuroChange(e.target.value)
              }}
              className=" outline-none w-full text-[18px] rounded-[16px] text-[#35258B] focus:text-[#5754E5] placeholder:text-[#D1D1FF]"
            />

          </div>
          
          {error && (
            <div className="text-[#EE443F] text-[14px] mt-1 sm:text-[11px]">
              {number === 0 &&
                (euroValue < 15 || euroValue > 5000) &&
                'Le montant à envoyer par Transfert doit être entre 15 et 5000 €'}
              {number === 1 &&
                (euroValue < 15 || euroValue > 5000) &&
                'Le montant à envoyer par Transfert doit être entre 15 et 5000 €'}
            </div>
          )}
        </div>
    
    </div>
    <div className={` text-[#5754E5] text-center text-[15px] font-semibold sm:text-[12px] flex items-center justify-center gap-2`}>
           Votre taux de change : {taux}{' '} + {' '}
          {taux !== undefined && euroValue >= 15 && euroValue <= 5000 && 
          crossedOutValue!==null && com===0 
            ?<div className='flex items-center gap-2'>
               <span className='line-through'>{crossedOutValue} €</span> <img src={Fleche} width={16} height={16} alt=''/> 
              <span className='bg-[#C3FFDB] text-[#20C374] font-bold px-2 rounded-[4px] flex items-center gap-2 w-auto'> 
              0.00 € <Gift styleCssImage='w-[15px] h-[15px]' color='#20C374'/></span> 
            </div>  
            
            : `${com} €  commission` }
        </div>
    </div>
  )
}
export default InputCalculateMontantEnvoyer
